// Cuenta regresiva del Día de la Madre (bloque countdown-madre).
//
// Un solo setInterval para todas las franjas de la página: en la ficha hay una,
// pero el editor del tema puede montar más de una y no tiene sentido un timer
// por cada una.

const SEL = '.lmCountdown[data-deadline]';

const pad = (n) => String(n).padStart(2, '0');

function build(el) {
  // La fecha llega del Liquid como "2026-10-16T23:59:00-03:00": lleva el offset
  // de Argentina adentro, así que Date.parse da el instante correcto en el huso
  // que tenga el visitante.
  const ts = Date.parse(el.dataset.deadline);

  if (Number.isNaN(ts)) {
    // Fecha mal cargada en el editor. Preferimos no mostrar nada antes que
    // mostrar un contador con NaN.
    el.hidden = true;
    return null;
  }

  const num = (unit) => el.querySelector(`[data-unit="${unit}"]`);
  const out = {
    days: num('days'),
    hours: num('hours'),
    minutes: num('minutes'),
    seconds: num('seconds'),
  };

  if (!out.days || !out.hours || !out.minutes || !out.seconds) {
    el.hidden = true;
    return null;
  }

  return { el, ts, out, sr: el.querySelector('[data-countdown-text]'), lastDays: null };
}

// Devuelve false cuando la franja ya no tiene que seguir actualizándose.
function paint(item, now) {
  let left = Math.floor((item.ts - now) / 1000);

  if (left <= 0) {
    // Llegó a cero: se esconde sola. El pedido es explícito en que no puede
    // quedar mostrando 00:00:00.
    item.el.hidden = true;
    return false;
  }

  const d = Math.floor(left / 86400);
  left -= d * 86400;
  const h = Math.floor(left / 3600);
  left -= h * 3600;
  const m = Math.floor(left / 60);
  const s = left - m * 60;

  item.out.days.textContent = pad(d);
  item.out.hours.textContent = pad(h);
  item.out.minutes.textContent = pad(m);
  item.out.seconds.textContent = pad(s);

  // El resumen para lector de pantalla se refresca sólo cuando cambia el día:
  // actualizarlo cada segundo haría que hable sin parar.
  if (item.sr && d !== item.lastDays) {
    item.lastDays = d;
    const dias = d === 1 ? '1 día' : `${d} días`;
    item.sr.textContent = `Quedan ${dias} para que termine la promoción por Día de la Madre.`;
  }

  item.el.hidden = false;
  return true;
}

let items = [];
let timer = null;

function tick() {
  const now = Date.now();
  items = items.filter((item) => paint(item, now));

  if (items.length === 0 && timer !== null) {
    clearInterval(timer);
    timer = null;
  }
}

function start() {
  items = Array.from(document.querySelectorAll(SEL)).map(build).filter(Boolean);
  if (items.length === 0) return;

  // Pintamos una vez ya mismo para no esperar un segundo con la franja oculta.
  tick();

  if (timer === null && items.length > 0) {
    timer = setInterval(tick, 1000);
  }
}

start();

// El editor del tema vuelve a montar las secciones sin recargar la página.
document.addEventListener('shopify:section:load', start);
